import { Requester } from './Requester';

// Firebase
import { getBaseURL } from '../firebase';

export const PostForMagicLink = async ({ email }: { email: string }): Promise<boolean> => {
    try {
        const response = await Requester<any>({
            path: `auth`,
            method: 'POST',
            payload: {
                email: (email ?? '').trim(),
                followUri: `${getBaseURL()}/login/landing`
            }
        });

        return response;
    } catch (e) {
        console.error('Magic link request failed');
        return Promise.reject(e);
    }
};
